<template>
  <v-select
    :value="value"
    :items="items"
    :clearable="clearable"
    :readonly="readonly"
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-select>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'BaseSelectFilter',

  mixins: [i18nRefreshData],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      items: []
    };
  },

  computed: {
    listeners() {
      return Object.assign({}, this.$listeners, {
        change: this.emitter
      });
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.getData().then(items => {
        this.items = items;
      });
    },

    emitter(data) {
      this.$emit('input', data);
      this.$emit('change', data);
    },

    /**
     * Get data items
     *
     * @returns {Promise<never>}
     */
    getData() {
      return Promise.reject(new Error('"getData" function is not implemented'));
    }
  }
};
</script>
